import { ga4Destination } from "@/lib/analytics/analytics.ga4";
import { gtmDestination } from "@/lib/analytics/analytics.gtm";
import { hubspotDestination } from "@/lib/analytics/analytics.hubspot";
import { mixpanelDestination } from "@/lib/analytics/analytics.mixpanel";
import { redditDestination } from "@/lib/analytics/analytics.reddit";
import type { AnalyticsDestination, AnalyticsTraits, EventProperties } from "@/lib/analytics/analytics.types";
import { xDestination } from "@/lib/analytics/analytics.x";

const destinations: AnalyticsDestination[] = [
  hubspotDestination,
  mixpanelDestination,
  ga4Destination,
  gtmDestination,
  redditDestination,
  xDestination,
];

const forEachDestination = (fn: (destination: AnalyticsDestination) => void): void => {
  for (const destination of destinations) {
    if (!destination.isEnabled()) {
      continue;
    }
    try {
      fn(destination);
    } catch (err) {
      if (process.env.NODE_ENV !== "production") {
        console.warn(`[analytics:${destination.name}]`, err);
      }
    }
  }
};

export const analytics = {
  pageView: (path: string) => {
    forEachDestination((d) => d.pageView(path));
  },
  track: (name: string, properties?: EventProperties) => {
    forEachDestination((d) => d.track(name, properties));
  },
  identify: (traits: AnalyticsTraits) => {
    forEachDestination((d) => d.identify(traits));
  },
  reset: () => {
    forEachDestination((d) => d.reset());
  },
};
